import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');
const isNumber = require('lodash/isNumber');

import Tooltip from '../common/Tooltip';

const propTypes = {
        actions: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string,
        iconClass: PropTypes.string,
        label: PropTypes.element,
        value: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
        group: PropTypes.number
    })),
    className: PropTypes.string,
};

const defaultProps = {
    actions: [],
    className: "",
};

function SideNav(props) {
        let actions = [];

        if (props.actions.length > 0) {
            const sortedActions = sortBy(props.actions, 'group');
            let lastGroup = null;

            actions = sortedActions.map((action) => {
                const firstActionInGroup = isNumber(action.group) && isNumber(lastGroup) && action.group !== lastGroup;
                lastGroup = action.group;

                return (
                    <div
                    className={`action-item ${firstActionInGroup && 'first-group-action'} ${action.radioActive && 'radio-active'}`}
                    style={action.bgColor ? { backgroundColor: action.bgColor } : {}}
                    key={action.value}>
                        <a href="#" onClick={action.handler}>
                            {action.icon ? <img src={action.icon} className="action-icon" aria-hidden="true" style={action.iconStyle}/> : null}
                            {!!action.iconClass ? <span className={`fa ${action.iconClass}`} aria-hidden="true" /> : null}
                            {action.label ? action.label : action.value}
                            { action.tooltip &&
                                <Tooltip className="margin-left-sm font-size-18px" id={`act-tt-${action.value}`} placement="bottom">
                                    {action.tooltip}
                                </Tooltip>
                            }
                        </a>
                        { action.child ? action.child : null }
                    </div>
                );
            });
        }

        return (
            <div className={`side-nav ${props.className}`}>
                <div className="action-list">
                    {actions}
                </div>
            </div>
        )
}

SideNav.propTypes = propTypes;
SideNav.defaultProps = defaultProps;

export default SideNav;